module.exports = __webpack_public_path__ + "static/media/iconCourses.8cf0f8ae.svg";